let prefix = '';
let suffix = '';

function updateTitle() {
  document.title = `${prefix}${suffix ? ` | ${suffix}` : ''}`;
}

export function setTitlePrefix(value: string) {
  prefix = value;
  updateTitle();
}

export function setTitleSuffix(value: string) {
  suffix = value;
  updateTitle();
}
